import React, { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import { getReq } from "../middleware/AxiosApisCall";
import { BsFillEyeFill } from "react-icons/bs";
import Loading from "../Loading";
import {
  Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper,TablePagination
} from '@mui/material';
import {HeaderTableCell,StyledTableRow,StyledTableCell} from '../Partials/TableStyle'
function PurchaseStockList() {
  const [stockList, setStockList] = useState([]);
  const [loading, setLoading] = useState(false);
  // const [searchValue, setSearchValue] = useState("");
  const path = "purchasestocklist";
  const navigate = useNavigate();
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(25);
  const [searchQuery, setSearchQuery] = useState("");
  //
  // https://officejeeves.com/api/purchasestocklist

  const fetchPurchasestocklist = async () => {
    const response = await getReq(`${path}`);
    setLoading(true);
    try{
      if (response?.success) {
        const sorteddata = response.data.sort((a,b)=>{
          return new Date(b.date) - new Date(a.date)
        })
        setStockList(sorteddata);
      }else{
        return false
      }
    }catch(error){
      console.log(error)
    }
   
  };
  // const filteredData = stockList.filter((item) => {
  //  const supplierfilter= item.supplier.toLowerCase().includes(searchValue.toLowerCase());
  //  const warehousefilter=item.warehouse.toLowerCase().includes(searchValue.toLowerCase());
  //  const invoicefilter=item.invoiceNumber.toLowerCase().includes(searchValue.toLowerCase());
  //  return supplierfilter ||  warehousefilter || invoicefilter
  // });
  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const filteredData = stockList.filter((item) => {
    return Object.values(item)
      .join(" ")
      .toLowerCase()
      .includes(searchQuery.toLowerCase());
  });
  
  const editClick = async (item) => {
    navigate(`../purchasestock/${item._id}`);
  };
  useEffect(() => {
    fetchPurchasestocklist();
  }, []);

  const handleSearch = (e) => {
    setSearchQuery(e.target.value);
  };


  // this function is for dateformate
  const formateDate = (isdate) => {
    const date = new Date(isdate);
    return date.toLocaleString();
  };
   // this function is for dateformate
   const formateDateWithoutTime = (isdate) => {
    const date = new Date(isdate);
    return date.toLocaleDateString();
  };

  return (
    <React.Fragment>
      {loading ? (
        <div className="add-user-container">
          <div className="headingdiv">
            <span className="componet-title">Purchase Stock List</span>
            <div>
              <button onClick={() => navigate(-1)}>Back</button>
            </div>
          </div>
          <div className="option-btn">
            <button
              onClick={() => {
                navigate("../purchasestock");
              }}
            >
              Purchase New Stock
            </button>
          </div>
          {/* <TableData path={path} editClick={editClick} /> */}

          <div className="componet-sub2-title">
            <div className="justi-spacebt">
              <span>
                Total:{stockList.length}
                {/* Total {props.path}: {tableData != null ? tableData.length : 0} */}
              </span>
              <div className="search-div">
                {/* <label>Search:</label>
                <input className="search-field" onChange={handleSearch} /> */}
                <label>Search : </label>
                <input value={searchQuery} onChange={handleSearch} variant="outlined" size="small"/>
              </div>
              
            </div>
          </div>
          {/* their */}
          {/* <div className="table_container-div">
            {filteredData.length > 0 ? (
              <table>
                <thead>
                  <tr>
                    <th>SL No</th>
                    <th>Warehouse</th>
                    <th>Supplier</th>
                    <th>Invoice No</th>
                    <th>GRN No</th>
                    <th>Date</th>
                    <th>Created At</th>
                    <th>Action</th>
                  </tr>
                </thead>
                {filteredData.map((item, i) => {
                  return (
                    <tbody key={i + 1}>
                      <tr>
                        <td>{i + 1}</td>
                        <td>{item.warehouse}</td>
                        <td>{item.supplier}</td>
                        <td>{item.invoiceNumber}</td>
                        <td>{item.GRN_Number}</td>
                        <td>{formateDate(item.date)}</td>
                        <td>{formateDate(item.createdAt)}</td>
                        <td>
                          <BsFillEyeFill
                            className="Edit-icon"
                            onClick={() => editClick(item)}
                          />
                        </td>
                      </tr>
                    </tbody>
                  );
                })}
              </table>
            ) : (
              <table>
                <tr>
                  <td> Data Not Found </td>
                </tr>
              </table>
            )}
          </div> */}
          {/* their */}
          <div className="table_container-div">
      {filteredData.length > 0 ? (
        <TableContainer component={Paper}>
          <Table>
            <TableHead>
              <StyledTableRow>
                <HeaderTableCell>SL No</HeaderTableCell>
                <HeaderTableCell>Warehouse</HeaderTableCell>
                <HeaderTableCell>Supplier</HeaderTableCell>
                <HeaderTableCell>Invoice No</HeaderTableCell>
                <HeaderTableCell>GRN No</HeaderTableCell>
                <HeaderTableCell>Date</HeaderTableCell>
                <HeaderTableCell>Created At</HeaderTableCell>
                <HeaderTableCell>Action</HeaderTableCell>
              </StyledTableRow>
            </TableHead>
            <TableBody>
              {filteredData.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage).map((item, index) => (
                <StyledTableRow key={index} sx={{
                  backgroundColor: index % 2 === 0 ? '#f5f5f5' : 'white',
                }}>
                  <StyledTableCell align="center">{index + 1}</StyledTableCell>
                  <StyledTableCell>{item.warehouse}</StyledTableCell>
                  <StyledTableCell>{item.supplier}</StyledTableCell>
                  <StyledTableCell>{item.invoiceNumber}</StyledTableCell>
                  <StyledTableCell>{item.GRN_Number}</StyledTableCell>
                  <StyledTableCell>{formateDateWithoutTime(item.date)}</StyledTableCell>
                  <StyledTableCell>{formateDate(item.createdAt)}</StyledTableCell>
                  <StyledTableCell align="center">
                    <BsFillEyeFill className="Edit-icon" onClick={() => editClick(item)} />
                  </StyledTableCell>
                </StyledTableRow>
              ))}
            </TableBody>
          </Table>
          <TablePagination
            rowsPerPageOptions={[10, 25, 50, 100]}
            component="div"
            count={filteredData.length}
            rowsPerPage={rowsPerPage}
            page={page}
            onPageChange={handleChangePage}
            onRowsPerPageChange={handleChangeRowsPerPage}
          />
        </TableContainer>
      ) : (
        <TableContainer component={Paper}>
          <Table>
            <TableBody>
              <StyledTableRow>
                <StyledTableCell colSpan={8} style={{ textAlign: 'center' }}>Data Not Found</StyledTableCell>
              </StyledTableRow>
            </TableBody>
          </Table>
        </TableContainer>
      )}
    </div>
        </div>
      ) : (
        <Loading />
      )}
    </React.Fragment>
  );
}

export default PurchaseStockList;
